import React from 'react';
import classnames from 'classnames';


function SkeletonLoader({ count, className }) {
  const loaderItems = [];
  for (let i = 0; i < count; i++) {
    loaderItems.push(i);
  }

  return (
    <div className={classnames('skeleton-loader', className)}>
      <div className="image-loader" />
      <div className="title-loader" />
    </div>

  );
}

export default React.memo(SkeletonLoader);
